import React, {useEffect, useState} from 'react'
import {Card, Segment} from 'semantic-ui-react'
import {Link} from 'gatsby'
import * as styles from './styles/productList.module.css'
import ImageHolder from '../ImageHolder';
import { resizeTimer } from '../../globalVar';
import AddToCartListing from '../AddToCart/addToCartListing';

const Negosyo = require('../../../lib/negosyo');
const Logger = require('../../../lib/logger');
const StylingTools = require('../../../lib/stylingTools');

const displayDateTime = (datestr) => {
	let monthlist=["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	let dateobj = new Date(datestr);

	return monthlist[dateobj.getMonth()]+" "+dateobj.getDate();

/*
	// 2021-08-27 - Remove Time info
	let timestr = "";
	let hours = dateobj.getHours();
	let mins = dateobj.getMinutes();
	let ampm = "";

	if (hours === 0) {
		if (mins > 0) {
			ampm = "am";
			timestr = "12";
		}
	} else if (hours > 0 && hours < 12) {
		ampm = "am";
		timestr = " "+hours;
	} else if (hours === 12) {
		ampm = "nn";
		timestr = " "+hours;
	} else if (hours < 23) {
		ampm = "pm";
		timestr = " "+(hours-12);
	} else {
		// Check against 23:59
		if (mins !== 59) {
			ampm = "pm";
			timestr = " "+(hours-12);
		}
	}

	if (mins < 59 && mins > 0) {
		// 59 is end of day
		if (mins < 10) {
			timestr = timestr+ ":0"+mins;
		} else {
			timestr = timestr+ ":"+mins;
		}
	}
	return monthlist[dateobj.getMonth()]+" "+dateobj.getDate()+timestr+ampm;
*/
}

const mapProductsToItems = (products, space, cameFrom, page, type, offset, listName, userExclusiveList) => {
	return products.map(({name, id, mainImageHref, meta, url, sku, available, squareImageHref, startdate, enddate, exclusive, uom }, index) => {
		let pricestr = "0.00"
		let priceval = 0
		if(meta) {
			pricestr = meta.display_price.with_tax.formatted
			priceval = meta.display_price.with_tax.amount
		}

		// Initialize exclusive values
		let exclusivestr = "0.00";
		let exclusiveval = 0;

		// Checks if user has registered to any franchise, seminar, course and exclusive rates are defined.
		if (userExclusiveList.length > 0 && exclusive !== undefined) {
			// Checks if product has special rates
			if (exclusive.length > 0) {
				// Filter the special rates applicable to the user
				const applicablePrices = exclusive.filter((e) => {
					return userExclusiveList.includes(e.code);
				})

				// Checks if there are any applicable special rates
				if (applicablePrices.length > 0) {
					let lowestApplicablePrice = applicablePrices[0].price;

					// Find the lowest price among the applicable special rates
					for (const applicablePrice of applicablePrices) {
						if (applicablePrice < lowestApplicablePrice) {
							lowestApplicablePrice = applicablePrice.price;
						}
					}

					// Set the exclusive price to be the lowest applicable special rate
					exclusiveval = lowestApplicablePrice;
				}

				// Format exclusive/special rate (add commas and decimal places)
				if (exclusiveval > 0) {
					exclusivestr = exclusiveval.toLocaleString('en-us', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					})
				}
			}
		}

		var daysleft = 0;
		if (startdate !== undefined && enddate !== undefined) {
			let datestartobj = new Date(startdate);
			let dateendobj = new Date(enddate);
			daysleft = Math.floor((dateendobj.getTime()-datestartobj.getTime())/(24*3600*1000));
			if (daysleft > 365) {
				daysleft = 0; /// so it won't display
			}
		}

		const productName = StylingTools.getTruncatedString(space, name, 2);

		return (
			<Card
				as={Link}
				to={`/${url}/`}
				state={{
					cameFrom,
					page,
					index:index+1
				}}
				draggable="false" // to prevent dragging link when higlighting text in add to cart input
				key={type==="product" ? id:url}
				onClick={()=>{
					if(type==="product") {
						let positionOffset = 0
						if(page && offset) {
							positionOffset= (page-1)*offset
						}
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							'event':'productClick',
							'ecommerce': {
								'click': {
									'actionField': {'list':listName},
									'products': [{
										'name':name,
										'id':sku,
										'price':priceval,
										'position':positionOffset+index+1,
										'item_id': sku,
										'item_name': name,
										'currency': "PHP",
										'index': positionOffset+index+1,
										'item_list_id': listName,
										'item_list_name': listName,
										'quantity': 1
									}]
								}
							}
						});
					}
				}}
			>
				<ImageHolder heightToWidthRatio={1} fluid alt={name} src={type==="category"? squareImageHref: mainImageHref} />
				<Card.Content className={styles.card}>
					<Card.Header className={styles.productname}>{productName}</Card.Header>
					<Card.Description className={`${styles.productDescription}`}>
						<Segment
							basic
							className={`${styles.priceContainer} ${exclusiveval > 0 ? styles.specialPrice : ''}`}
						>	
							{exclusiveval > 0 && ( priceval > 0
								? <span>Special Member Price</span>
								: <span>Exclusive Item</span>
							)}

							{/* PRICE */}
							{ priceval > 0 || exclusiveval > 0
								? <>
									<p className={`${styles.productPrice}`}>
										<span>&#8369;
											{exclusiveval > 0 ? exclusivestr : pricestr}
										</span>

										{/* UOM */}
										{/* Remove the false when uom is ready to be displayed */}
										{uom !== undefined && false && <>
											{uom.length > 0 ? <><br/>/{uom}</> : ""}
										</>}
									</p>
								</>
								: available === false && <>
									<p><span>Exclusive Item</span></p>
								</>
							}
						</Segment>
						<div className={`${styles.meta} ${styles.warningMessage}`}>
							{ exclusiveval > 0
								? priceval > 0
									? <p className={`${styles.regularPrice}`}>
										Regularly <span>&#8369;{pricestr}</span>
									</p>
									: <>&nbsp;</>
								: available === false && priceval > 0
									? <>Product no longer available.</>
									: <>&nbsp;</>

							}
							{!(priceval > 0 || exclusiveval > 0) && available === false && 
								<>For selected members only</>
							}
						</div>
					</Card.Description>
				</Card.Content>
				<AddToCartListing 
					disabled={exclusiveval === 0 && available === false} 
					product={{
						id,
						name, 
						price: meta.display_price.with_tax.amount, 
						sku,
						image: type==="category"? squareImageHref: mainImageHref
					}}
				/>
				{ (daysleft>0) &&
					<Card.Content extra>
						<div className={`${styles.meta} ${styles.warningMessage}`}>{displayDateTime(startdate)}{" to "+displayDateTime(enddate)+" only"}</div>
					</Card.Content>

				}
			</Card>
		)
	})
}

const ProductListComponent = ({products, shown, grid, cameFrom, page, offset, listName, type="product", exclusivelist=[]}) => {
	const [windowWidth, setWindowWidth] = useState(0)
	const [userExclusiveList, setUserExclusiveList] = useState(exclusivelist);

	useEffect(() => {
		handler();
		
		let timeOut = null;

		const resizeConsolidator = () => {
			clearTimeout(timeOut);
			timeOut = setTimeout(handler, resizeTimer);
		}

		window.addEventListener("resize", resizeConsolidator);

		return () => {
			clearTimeout(timeOut)
			window.removeEventListener("resize", resizeConsolidator)
		}
	}, [])

	const handler = () => {
		setWindowWidth(window.innerWidth);
	}

	useEffect(() => {
		if(userExclusiveList.length < 1) {
			Negosyo.getCurrentUserDetails()
			.then((user) => {
				Negosyo.getUserProfile(user.username, "exclusivelist")
				.then((userProfile) => {
					if (userProfile.status === "OK") {
						setUserExclusiveList(userProfile.data);
					};
				}).catch((err) => {
					Logger.log(err);
				})
			}).catch((err) => {
				Logger.log(err);
			})
		}
	}, []);

	useEffect(()=>{
		if(type==="product") {
			let positionOffset = 0
			if(page && offset) {
				positionOffset= (page-1)*offset
			}
			const dataLayerList = products.map(({name, sku, meta}, index)=>{
				return {
					'name': name,
					'id': sku,
					'price': parseFloat(meta.display_price.with_tax.amount),
					'list': listName,
					'position':positionOffset+index+1,
					'item_id': sku,
					'item_name': name,
					'currency': "PHP",
					'index': positionOffset+index+1,
					'item_list_id': listName,
					'item_list_name': listName,
					'quantity': 1
				}
			})
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'productList',
				'ecommerce': {
					'impressions': dataLayerList
				}
			});
		}
		/*Sept. 16 2020
		 *[product[0].url] works because when getting new products, the productList gets unmounted and a Loader is replaced with it
		 *though this assumes that the product url will always be unique and that the product list will get unmounted while getting new products
		 */
	}, [products[0].url])

	const { space } = StylingTools.getCharacterRowSpaceByWindow(windowWidth, shown/(grid/16));

	return (
		<Card.Group
			itemsPerRow={shown}
		>
			{mapProductsToItems(products, space, cameFrom, page, type, offset, listName, userExclusiveList)}
		</Card.Group>
	)
}

export default ProductListComponent
